<template>
  <div class="preservation-addbqdbxx">
    <MyTitle theTitle="担保信息" />
      <van-cell-group class="fd-com-scroll">
        <!-- 担保方式 -->
        <van-field
          v-model="formData.cDbfsText"
          required
          clearable
          readonly
          label="担保方式"
          right-icon="arrow"
          placeholder="请选择担保方式"
          @click="showDbfs = true"
        ></van-field>
        <van-popup v-model="showDbfs" position="bottom">
          <van-picker
            show-toolbar
            :columns="columnsDbfs"
            :default-index="0"
            @cancel="showDbfs = false"
            @confirm="onDbfsConfirm"
          ></van-picker>
        </van-popup>

        <van-cell-group v-if="formData.cDbfs == 5">
          <!-- <van-cell class="van-cell--required" title="是否通过本系统申请购买的保险公司诉责险"/> -->
        </van-cell-group>
        <!-- 是否线上诉责险 -->
        <van-radio-group v-model="formData.nSysbuy" v-if="formData.cDbfs == 5">
          <van-cell-group>
            <van-cell title="系统自动关联担保" clickable @click="radio = 1">
              <van-radio slot="right-icon" :name="1" />
            </van-cell>
            <van-cell title="手动填写担保相关信息" clickable @click="radio = 2">
              <van-radio slot="right-icon" :name="2" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>

        <!--担保方式为 诉责险 线上-->
        <div v-if="formData.cDbfs == 5 && formData.nSysbuy === 1" key="szx_xs">
          <template v-if="hasUsebxgsVos">
            <van-field
              v-model="formData.cDbr51"
              label="担保人"
              placeholder="请输入担保人"
            ></van-field>
            <van-field
              v-model="formData.cBxgsmc51"
              required
              readonly
              right-icon="arrow"
              label="担保机构名称"
              placeholder="请选择担保机构"
              @click="showBxgs = true"
            ></van-field>
            <van-popup v-model="showBxgs" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsBxgs"
                :default-index="0"
                @cancel="showBxgs = false"
                @confirm="onBxgsConfirm"
              ></van-picker>
            </van-popup>
            <van-field
              v-model="formData.cBdh51"
              required
              readonly
              label="保单号"
              right-icon="arrow"
              placeholder="请选择保单号"
              @click="showBdh = true"
            ></van-field>
            <van-popup v-model="showBdh" position="bottom">
              <van-picker
                show-toolbar
                :columns="columnsBdh"
                :default-index="0"
                @cancel="showBdh = false"
                @confirm="onBdhConfirm"
              ></van-picker>
            </van-popup>
            <van-field
              v-model="formData.nDbjz51"
              required
              readonly
              label="担保价值（元）"
              placeholder="请输入担保价值"
              maxlength="13"
            ></van-field>
            <van-field
              v-model="formData.cDbsm51"
              label="担保说明"
              placeholder="请输入担保说明"
            ></van-field>
          </template>
          <div
            class="fd-com-warning-tip"
            v-if="isShowTs === 1">
            当前未关联到有效的担保，请手动填写
          </div>
        </div>
        <!--担保方式为 诉责险 线下-->
        <div v-if="formData.cDbfs == 5 && formData.nSysbuy === 2" key="szx_xx">
          <van-field
            v-model="formData.cDbr52"
            label="担保人"
            placeholder="请输入担保人"
          ></van-field>
          <van-field
            v-model="formData.cBxgsmc52"
            required
            label="担保机构"
            placeholder="请输入担保机构"
          ></van-field>
          <van-field
            v-model="formData.nDbjz52"
            required
            label="担保价值(元)"
            placeholder="请输入担保价值"
            maxlength="13"
          ></van-field>
          <van-field
            v-model="formData.cDbsm52"
            label="担保说明"
            placeholder="请输入担保说明"
          ></van-field>
        </div>
        <!--交纳保证金-->
        <div v-if="formData.cDbfs == 1">
          <van-field
            v-model="formData.cDbr1"
            label="担保人"
            placeholder="请输入担保人"
          ></van-field>
          <van-field
            v-model="formData.nDbjz1"
            required
            label="担保价值(元)"
            placeholder="请输入担保价值"
            maxlength="13"
          ></van-field>
          <van-field
            v-model="formData.cDbsm1"
            label="担保说明"
            placeholder="请输入内容"
          ></van-field>
        </div>
        <!--提供保证人-->
        <div v-if="formData.cDbfs == 2">
          <van-field
            v-model="formData.cDbr2"
            required
            label="担保人"
            placeholder="请输入担保人"
          ></van-field>
          <van-field
            v-model="formData.cDbwmc2"
            required
            label="担保物名称"
            placeholder="请输入担保物名称"
          ></van-field>
          <van-field
            v-model="formData.nDbjz2"
            required
            label="担保价值(元)"
            placeholder="请输入担保价值"
            maxlength="13"
          ></van-field>
          <van-field
            v-model="formData.cDbsm2"
            label="担保说明"
            placeholder="请输入内容"
          ></van-field>
        </div>
        <!--设定抵押-->
        <div v-if="formData.cDbfs == 3">
          <van-field
            v-model="formData.cDbr3"
            label="担保人"
            placeholder="请输入担保人"
          ></van-field>
          <van-field
            v-model="formData.cCclxText3"
            required
            readonly
            right-icon="arrow"
            label="抵押财产类型"
            placeholder="请选择抵押财产类型"
            @click="showDylx = true"
          ></van-field>
          <van-popup v-model="showDylx" position="bottom">
            <van-picker
              show-toolbar
              :columns="columnsDylx"
              :default-index="0"
              @cancel="showDylx = false"
              @confirm="onDylxConfirm"
            >
            </van-picker>
          </van-popup>
          <van-field
            v-model="formData.nDbjz3"
            required
            label="担保价值(元)"
            placeholder="请输入担保价值"
            maxlength="13"
          ></van-field>
          <van-field
            v-model="formData.cDbsm3"
            label="担保说明"
            placeholder="请输入内容"
          ></van-field>
        </div>
        <!--设定质押-->
        <div v-if="formData.cDbfs == 4">
          <van-field
            v-model="formData.cDbr4"
            label="担保人"
            placeholder="请输入担保人"
          ></van-field>
          <van-field
            v-model="formData.cCclxText4"
            required
            readonly
            right-icon="arrow"
            label="质押财产类型"
            placeholder="请选择质押财产类型"
            @click="showZylx = true"
          ></van-field>
          <van-popup v-model="showZylx" position="bottom">
            <van-picker
              show-toolbar
              :columns="columnsZylx"
              :default-index="0"
              @cancel="showZylx = false"
              @confirm="onZylxConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.nDbjz4"
            required
            label="担保价值(元)"
            placeholder="请输入担保价值"
            maxlength="13"
          ></van-field>
          <van-field
            v-model="formData.cDbsm4"
            label="担保说明"
            placeholder="请输入内容"
          ></van-field>
        </div>
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
          v-if="!formData.cId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addDbxx(true)"
        >
          添加
        </van-button>
        <van-button
          v-if="formData.cId"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addDbxx(true)"
        >
          确定
        </van-button>
        <van-button
          v-if="!formData.cId"
          type="info"
          round
          :disabled="!saveBtnClickable"
          @click="addDbxx(false)"
        >
          确认并继续添加
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import { columnsDBFS, columnsDycclx } from "../../../utils/option";
import validate from "@/utils/validator/validator";
import { typeCclx, typeDbfs, BXGS, typeSddy } from "../../../filters/index";
import {
  bdhRule,
  SmRule,
  DbjzRule,
  DbrRule,
  dbfsRule,
  cclxRule,
  bxgsRule,
  DbwmcRule,
  BxgsmcRule,
} from "@/utils/validator/rules";

export default {
  data() {
    return {
      cBqlx: "", // 保全类型
      bqid: "",
      ydbh: "", // 原担保号
      cId: "",
      deId: "",
      formData: {
        /**
         * 公共字段
         */
        cId: "",
        cSzxid: "",
        cDbfs: 5,
        cOldDbfs: "",
        cDbfsText: "保险公司诉责险",
        nSysbuy: 1,
        nOldSysbuy: "",

        /**
         *  交纳保证金
         */
        cDbr1: "",
        nDbjz1: "",
        cDbsm1: "",

        /**
         *  提供保证人
         */
        cDbr2: "",
        cDbwmc2: "",
        nDbjz2: "",
        cDbsm2: "",

        /**
         *  设定抵押
         */
        cDbr3: "",
        nDbjz3: "",
        cDbsm3: "",
        cCclx3: "",
        cCclxText3: "",

        /**
         *  设定质押
         */
        cDbr4: "",
        nDbjz4: "",
        cDbsm4: "",
        cCclx4: "",
        cCclxText4: "",

        /**
         *  诉责险-线上
         */
        cDbr51: "",
        nDbjz51: "",
        cDbsm51: "",
        cBxgs51: "",
        cBxgsmc51: "",
        cBdh51: "",
        cLy51: "",
        /**
         *  诉责险-线下
         */
        cDbr52: "",
        nDbjz52: "",
        cDbsm52: "",
        cBxgsmc52: "",
      },
      showDbfs: false,
      showZylx: false,
      showDylx: false,
      showBxgs: false,
      showBdh: false,
      // columnsDbfs: columnsDBFS,
      columnsDbfs: [],
      columnsDylx: columnsDycclx,
      columnsZylx: columnsDycclx,
      /*columnsBxgs: [],
                columnsBdh: [],*/
      dbJbxxs: [],
      bxgxCorreDbh: [],
      dbxxList: [],
      bxgsList: [],
      saveBtnClickable: true, // 保存按钮是否可以点击
    };
  },
  components: {
    MyTitle,
  },
  computed: {
    // 是否有可用诉责险
    hasUsebxgsVos() {
      let arr = [];
      if (this.ydbh) {
        arr.push(this.ydbh);
      }
      let usedBdhArr = new Set([]);
      this.dbxxList.map((item) => {
        usedBdhArr.add(item.cBdh);
      });
      this.bxgsVos.map((bdhList) => {
        bdhList.dbJbxxs.map((item) => {
          if (!usedBdhArr.has(item.cBdh)) {
            arr.push(item.cBdh);
          }
        });
      });
      return arr.length;
    },
    bxgsVos() {
      let idList = new Set([]); // 保存唯一id的数组
      let a = this.dbxxList; // 担保基本信息列表
      let c = this.bxgsList; // 担保机构列表
      let b = []; // 数据合并后的结果
      // 过滤数据
      let result_filter_a = a.filter((item) => {
        return item.cDbfs === "5" && item.nSysbuy === 1;
      });
      // 将担保基本信息列表数据插入到结果中
      result_filter_a.map((item_a) => {
        // 通过id判断是否重复添加
        if (idList.has(item_a.cBxgs)) {
          b.map((item_b) => {
            // 通过id将数据添加到对应的结果中
            if (item_b.id === item_a.cBxgs) {
              item_b.dbJbxxs.push(item_a);
            }
          });
        } else {
          // 没有此id，则直接生成对应数据
          b.push({
            id: item_a.cBxgs,
            name: item_a.cBxgsmc,
            dbJbxxs: [{ ...item_a }],
          });
        }
        // 数据添加完毕，将id添加到储存id的数组中
        idList.add(item_a.cBxgs);
      });
      // 将担保机构列表数据插入到结果中
      // 逻辑同上
      c.map((item_c) => {
        if (idList.has(item_c.id)) {
          b.map((item_b) => {
            if (item_b.id === item_c.id) {
              // 此处需要合并数组
              item_b.dbJbxxs = [...item_b.dbJbxxs, ...item_c.dbJbxxs];
            }
          });
        } else {
          b.push({
            id: item_c.id,
            name: item_c.name,
            dbJbxxs: [...item_c.dbJbxxs],
          });
        }
        idList.add(item_c.cBxgs);
      });
      // 返回结果-结束
      return b;
    },
    /**
     *  选中的保单号
     */
    selectBdhArr() {
      return this.dbxxList
        .filter((item) => {
          return item.cDbfs === "5";
        })
        .map((item) => item.cBdh);
    },
    /**
     * 保单号列表
     * @returns {Array}
     */
    columnsBdh() {
      let arr = [];
      //遍历担保机构列表
      this.bxgsVos.map((item) => {
        // 寻找选中的担保机构列表
        if (item.id === this.formData.cBxgs51) {
          console.log("000000", this.selectBdhArr);
          // 去除已选择的保单号
          arr = item.dbJbxxs.filter((item) => {
            return this.selectBdhArr.indexOf(item.cBdh) > -1 ? false : true;
            // return this.selectBdhArr
          });
        }
      });

      return arr.map((item) => {
        console.log("----------bdh" + item);
        return {
          keyId: item.cId,
          text: item.cBdh,
          nDbjz: item.nDbjz,
        };
      });
    },
    columnsBxgs() {
      return this.bxgsList.map((item) => {
        return {
          keyId: item.id,
          text: item.name,
        };
      });
    },
    isShow() {
      if (this.formData.cDbfs == 5 && this.columnsBxgs.length > 0) {
        return "2";
      } else {
        return "1";
      }
    },
    isShowTs() {
      console.log("111111", this.columnsBxgs.length);
      if (
        this.formData.cDbfs == 5 &&
        this.columnsBdh.length === 0 &&
        this.columnsBxgs.length === 0 &&
        this.formData.cId === ""
      ) {
        return 1;
      } else {
        return 2;
      }
    },
    params() {
      let obj = {
        cId: "",
        cSzxid: "",
        cDbfs: 5,
        cOldDbfs: "",
        cDbfsText: "保险公司诉责险",
        nSysbuy: 1,
        nOldSysbuy: "",
        cLy: "",
      };
      let { cDbfs } = this.formData;
      let { nSysbuy } = this.formData;

      let nameData = {
        arr: ["cId", "cSzxid", "cDbfs", "cOldDbfs", "nSysbuy", "nOldSysbuy"],
        arr1: ["cDbr", "nDbjz", "cDbsm"],
        arr2: ["cDbr", "cDbwmc", "nDbjz", "cDbsm"],
        arr3: ["cDbr", "nDbjz", "cDbsm", "cCclx", "cCclxText"],
        arr4: ["cDbr", "nDbjz", "cDbsm", "cCclx", "cCclxText"],
        arr51: ["cDbr", "nDbjz", "cDbsm", "cBxgs", "cBxgsmc", "cBdh", "cLy"],
        arr52: ["cDbr", "nDbjz", "cDbsm", "cBxgsmc"],
      };
      nameData.arr.map((key) => {
        obj[key] = this.formData[key];
        if (
          (key === "nSysbuy" && obj[key] === 2) ||
          (key === "cDbfs" && obj[key].toString() !== "5")
        ) {
          obj["cSzxid"] = null;
        }
      });

      if (cDbfs == 5) {
        let keyName = "arr" + cDbfs + nSysbuy;
        // 遍历赋值
        nameData[keyName].map((key) => {
          obj[key] = this.formData[key + cDbfs + nSysbuy];
        });
      } else {
        let keyName = "arr" + cDbfs;
        // 遍历赋值
        nameData[keyName].map((key) => {
          obj[key] = this.formData[key + cDbfs];
        });
        obj.cSzxid = null;
        obj.nSysbuy = null;
      }

      return obj;
    },
  },
  methods: {
    /**
     * 初始化担保信息
     */
    initDbxxData(dbid) {
      this.$axios
        .get("ssbq/api/ssdb/dbjbxx?dbid=" + dbid)
        .then((res) => {
          if (res.code == 200) {
            if (res.data != "") {
              /**
               * 公共字段
               * @type {string[]}
               */
              let arr = [
                "cId",
                "cSzxid",
                "cDbfs",
                "cOldDbfs",
                "nSysbuy",
                "nOldSysbuy",
              ];
              arr.map((key) => {
                this.formData[key] = res.data[key];
              });
              let { cDbfs } = res.data;
              let { nSysbuy } = res.data;
              let { cBxgs } = res.data;
              let { cBxgsmc } = res.data;
              this.formData.cDbfsText = typeDbfs(cDbfs);
              this.formData.cBxgsmc51 = cBxgsmc;
              if (cDbfs === "5") {
                // 如果是诉责险
                for (let key in res.data) {
                  let formDataKey = key + cDbfs + nSysbuy;
                  if (this.formData[formDataKey] !== undefined) {
                    this.formData[formDataKey] = res.data[key];
                  }
                }
                if (res.data.nSysbuy == 1) {
                  this.formData.cOldDbfs = "5";
                  this.formData.nOldSysbuy = 1;
                  this.ydbh = res.data.cBdh;
                }
                if (res.data.nSysbuy == 2) {
                  this.formData.cOldDbfs = "5";
                  this.formData.nOldSysbuy = 2;
                }
                console.log("---------{}", this.formData);
              } else {
                // 如果是非诉责险
                for (let ke in res.data) {
                  let formDataKe = ke + cDbfs;
                  if (this.formData[formDataKe] !== undefined) {
                    this.formData[formDataKe] = res.data[ke];
                    if (ke == "cCclx") {
                      let cclxmc = "cCclxText" + cDbfs;
                      this.formData[cclxmc] = typeSddy(res.data[ke]);
                    }
                  }
                }
                this.formData.cOldDbfs = res.data["cDbfs"];
                this.formData.nOldSysbuy = res.data["nSysbuy"];
                this.formData.nSysbuy = 1;
              }
            }
          } else {
            this.$notify(res.message);
          }
        })
        .catch(() => {});
    },
    /**
     * 添加担保信息
     */
    addDbxx(type) {
      if (
        this.columnsBxgs.length == 0 &&
        this.formData.cDbfs == 5 &&
        this.formData.nSysbuy == 1
      ) {
        this.$notify("当前没有可用的保险公司诉责险");
        return;
      }
      const validateFormData = this.validateFormData();
      validateFormData.then(() => {
        this.submitDbxx().then(() => {
          if (type) {
            this.$router.go(-1);
          } else {
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        });
      });
    },
    /**
     * 提交担保信息
     */
    submitDbxx: function () {
      this.saveBtnClickable = false;
      return this.$axios
        .post(
          "ssbq/api/xcx/hxcxbqxx?bqid=" + this.bqid + "&id=" + this.deId,
          this.params
        )
        .then((res) => {
          if (res.code == 200) {
            this.$notify({ type: "success", message: "操作成功" });
          } else {
            this.$notify(res.message);
          }
        })
        .catch(() => {});
    },
    /**
     * 担保方式
     * @param item
     */
    onDbfsConfirm(item) {
      this.formData.cDbfs = item.keyId;
      this.formData.cDbfsText = item.text;
      this.showDbfs = false;
    },
    /**
     * 抵押类型
     * @param item
     */
    onDylxConfirm(item) {
      this.formData.cCclx3 = item.keyId;
      this.formData.cCclxText3 = item.text;
      this.showDylx = false;
    },
    /**
     * 质押类型
     * @param item
     */
    onZylxConfirm(item) {
      this.formData.cCclx4 = item.keyId;
      this.formData.cCclxText4 = item.text;
      this.showZylx = false;
    },
    /**
     * 担保机构
     * @param item
     */
    onBxgsConfirm(item) {
      this.formData.cBxgs51 = item.keyId;
      this.formData.cBxgsmc51 = item.text;
      this.formData.cBdh51 = "";
      this.formData.nDbjz51 = "";
      /*let dbhs = [];
                this.bxgxCorreDbh.forEach((dbItem) => {
                    if (dbItem.id == item.keyId) {
                        dbhs = dbItem.dbJbxxs;
                    }
                });
                dbhs.forEach((db) => {
                    let dbh = {};
                    dbh.keyId = db.cBdh;
                    dbh.text = db.cBdh;
                    this.columnsBdh.push(dbh);
                })*/
      this.showBxgs = false;
    },
    /**
     * 保单号
     * @param item
     */
    onBdhConfirm(item) {
      this.formData.cBdh51 = item.keyId;
      this.formData.cBdh51 = item.text;
      this.formData.cSzxid = item.keyId;
      this.formData.nDbjz51 = item.nDbjz;
      this.dbJbxxs.forEach((dbItem) => {
        if (dbItem.cBdh == item.keyId) {
          this.cId = dbItem.cId;
          this.formData.cSzxid = dbItem.cId;
          this.formData.nDbjz51 = dbItem.nDbjz;
        }
      });

      this.showBdh = false;
    },
    /**
     * 表单验证
     */
    validateFormData: function () {
      let dbfs;
      if (this.formData.cDbfs == 5) {
        dbfs = this.formData.cDbfs + "" + this.formData.nSysbuy;
      } else {
        dbfs = this.formData.cDbfs + "";
      }
      let descriptor = {
        cDbfs: dbfsRule,
      };
      if (
        this.columnsBxgs.length == 0 &&
        this.formData.cDbfs == 5 &&
        this.formData.nSysbuy == 1
      ) {
        this.$notify("当前没有可用的保险公司诉责险");
        return;
      }
      let data = Object.assign({}, this.formData);
      data.cDbfs = this.formData.cDbfs;
      switch (dbfs) {
        case "1":
          descriptor = {
            cDbr: new DbrRule(false),
            nDbjz: new DbjzRule(true),
            cDbsm: new SmRule(false),
          };
          data.nDbjz = this.formData.nDbjz1;
          data.cDbr = this.formData.cDbr1;
          data.cDbsm = this.formData.cDbsm1;
          break;
        case "2":
          descriptor = {
            cDbr: new DbrRule(true),
            nDbjz: new DbjzRule(true),
            cDbwmc: new DbwmcRule(true),
            cDbsm: new SmRule(false),
          };
          data.cDbr = this.formData.cDbr2;
          data.cDbwmc = this.formData.cDbwmc2;
          data.nDbjz = this.formData.nDbjz2;
          data.cDbsm = this.formData.cDbsm2;
          break;
        case "3":
          descriptor = {
            cDbr: new DbrRule(false),
            cCclx: cclxRule,
            nDbjz: new DbjzRule(true),
            cDbsm: new SmRule(false),
          };
          data.cCclx = this.formData.cCclx3;
          data.nDbjz = this.formData.nDbjz3;
          data.cDbr = this.formData.cDbr3;
          data.cDbsm = this.formData.cDbsm3;
          break;
        case "4":
          descriptor = {
            cDbr: new DbrRule(false),
            cCclx: cclxRule,
            nDbjz: new DbjzRule(true),
            cDbsm: new SmRule(false),
          };
          data.cCclx = this.formData.cCclx4;
          data.nDbjz = this.formData.nDbjz4;
          data.cDbr = this.formData.cDbr4;
          data.cDbsm = this.formData.cDbsm4;
          break;
        case "51":
          descriptor = { cBxgs: bxgsRule, cBdh: bdhRule };
          data.cBdh = this.formData.cBdh51;
          data.cBxgs = this.formData.cBxgs51;
          break;
        case "52":
          descriptor = {
            cDbr: new DbrRule(false),
            cBxgsmc: new BxgsmcRule(true),
            nDbjz: new DbjzRule(true),
            cDbsm: new SmRule(false),
          };
          data.cBxgsmc = this.formData.cBxgsmc52;
          data.nDbjz = this.formData.nDbjz52;
          data.cDbr = this.formData.cDbr52;
          data.cDbsm = this.formData.cDbsm52;
          break;
      }
      let validated = validate(descriptor, data);
      return validated;
    },

    getBqDbxx() {
      this.$axios.get("ssbq/api/dbxxs?bqid=" + this.bqid).then((res) => {
        this.dbxxList = res.data;
      });
    },
    getBxgs() {
      this.$axios.get("ssbq/api/bqsq/ccbqzrx?bqid=" + this.bqid).then((res) => {
        this.bxgsList = res.data.bxgsVos;
      });
    },
    getBqjbxx(bqid) {
      this.$axios.get("ssbq/api/bqsqinfo?bqid=" + bqid).then((res) => {
        if (res.code === 200) {
          var data = res.data;
          this.cBqlx = data.cBqlx;
          if (!this.formData.cId) {
            //新增
            if (data.cBqlx === "1" && data.cBqlb !== "4") {
              this.formData.cDbfs = "5";
              this.formData.nSysbuy = 1;
              this.columnsDbfs = columnsDBFS;
            } else {
              this.formData.cDbfs = "1";
              this.formData.nSysbuy = null;
              console.log("--this.columnsDBFS 111", this.columnsDbfs);
              this.columnsDbfs = columnsDBFS.filter(
                (item) => item.keyId !== "5"
              );
              this.formData.cDbfsText = columnsDBFS.filter(
                (item) => item.keyId === "1"
              )[0].text;
              console.log("--this.columnsDBFS 222", this.columnsDbfs);
            }
          } else {
            if (data.cBqlx === "1" && data.cBqlb !== "4") {
              this.columnsDbfs = columnsDBFS;
            } else {
              this.columnsDbfs = columnsDBFS.filter(
                (item) => item.keyId !== "5"
              );
            }
          }
        }
      });
    },
  },
  async created() {
    // 获取担保id
    let dbid = JSON.parse(sessionStorage.getItem("cDbxxId"));
    this.formData.cId = dbid;
    // 当前保全id
    let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
    this.bqid = currentBqid;

    await this.getBqjbxx(currentBqid);
    // if(dbid){
    await this.initDbxxData(dbid);
    // }
    await this.getBqDbxx();
    await this.getBxgs();
  },
};
</script>

<style lang="less" scoped>
.preservation-addbqdbxx {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .advice-amount {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: right;

    > span {
      color: #fe4d67;
      font-size: 14px;
      margin-right: 30/2px;
    }
  }
}
</style>
